import { Box, Spinner, Text, Flex, Badge } from '@chakra-ui/react'
import { useMapCoreManager } from '../../contexts/MapCoreManager/Provider'
import { getAfaCodeFormat } from 'modules/Geo/utils/afacode/getAfaCodeFormat'

export default function MarkingDataCard() {
  const { markingData, queryingMarkingData, navbar } = useMapCoreManager()

  function formatAddress(address: any) {
    if (!address) return ''

    const road = address.road || address.pedestrian || address.footway || ''

    const neighborhood = address.suburb || address.neighbourhood || address.quarter || ''

    const city = address.city || address.town || address.village || address.municipality || ''

    const state = address.state || ''
    const postcode = address.postcode || ''

    const parts = [road, neighborhood, city && state ? `${city} - ${state}` : city || state, postcode].filter(Boolean) // remove vazios

    return parts.join(', ')
  }

  return (
    <Box
      p={2}
      top={navbar ? '50px' : '0px'}
      w="full"
      //   bg="white"
      pos={'absolute'}
      borderBottom={'1px solid'}
      borderColor={'borderColor'}
      bg="bgContainer"
    >
      <Text fontSize="sm" fontWeight="medium">
        Endereço selecionado:
      </Text>
      <Flex flexDir="column" gap={2}>
        {markingData?.address ? (
          <Text fontSize="sm" color="primary" noOfLines={3} mt={1}>
            {formatAddress(markingData?.address?.address)}
          </Text>
        ) : (
          <Text fontSize="sm" color="primary" noOfLines={3} mt={1}>
            Mova o mapa para selecionar o local
          </Text>
        )}

        <Flex alignItems={'center'} gap={2}>
          <Text fontSize="sm" fontWeight="medium">
            Código AFA:
          </Text>
          <Badge>{getAfaCodeFormat(markingData?.afacode)}</Badge>
        </Flex>
      </Flex>
    </Box>
  )

  return (
    <Box
      p={2}
      mt="50px"
      //   bg="white"
      borderBottom={'1px solid'}
      borderColor={'borderColor'}
      bg="bgContainer"
    >
      <Text fontSize="sm" fontWeight="medium">
        Endereço selecionado:
      </Text>
      {queryingMarkingData ? (
        <Spinner size="sm" mt={1} />
      ) : (
        <Flex flexDir="column" gap={2}>
          {markingData?.address ? (
            <Text fontSize="sm" color="primary" noOfLines={3} mt={1}>
              {formatAddress(markingData?.address?.address)}
            </Text>
          ) : (
            <Text fontSize="sm" color="primary" noOfLines={3} mt={1}>
              Mova o mapa para selecionar o local
            </Text>
          )}

          <Flex alignItems={'center'} gap={2}>
            <Text fontSize="sm" fontWeight="medium">
              Código AFA:
            </Text>
            <Badge>{markingData?.afacode}</Badge>
          </Flex>
        </Flex>
      )}
    </Box>
  )
}
